import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import { Box, Button, FormLabel, Grid } from '@mui/material';
import { BiSolidError } from 'react-icons/bi';
import MoveEndMap from '../../MoveEndMap';
import DataContext from '../../../../context/users/DataContextCopy';
import DetailMap from '../../DetailMap';

// 텍스트 필드, 메뉴아이템 커스터마이징
function DeclareAnswer() {
  const { checkList, num, handleDelete, myName, myCall, userPwdCheck } = useContext(DataContext);

  const navigate = useNavigate();
  let list = [];
  if (checkList) {
    Object.values(checkList).forEach(item => {
      if (item?.mw_id === num) {
        list.push(item);
      }
    });
  }

  const [mapClickEnabled, setMapClickEnabled] = useState(false);

  // 페이지 진입 시 상세보기 지도 상호작용 비활성화
  useEffect(() => {
    setMapClickEnabled(false);
  }, []);

  useEffect(() => {
    console.log('myName', myName, 'myCall', myCall, 'userPwdCheck', userPwdCheck);
  }, [myName, myCall, userPwdCheck]);

  // 지도 클릭 이벤트 핸들러
  const handleMapClick = () => {
    if (!mapClickEnabled) {
      return; // 지도 클릭이 비활성화된 경우 처리하지 않음
    }
    // 클릭 이벤트 처리 로직
  };

  const handleDeleteConfirmation = async () => {
    const confirmed = window.confirm('정말 삭제하시겠습니까?');
    if (confirmed) {
      if (myName === "" || myCall === "" || userPwdCheck === "") {
        alert('삭제 실패');
        return;
      } else {
        await handleDelete();
        navigate('//');
        window.location.reload(); // 페이지 새로고침
      }
    }
  };

  if (checkList === null) {
    return (
      <div>
        <div className='declarelist-container'>
          <div className='declarelist-box'>
            <div className='declarelist-contents' style={{ height: '50vh', paddingTop: 50 }}>
              <BiSolidError fontSize={30} />
              <p>휴대폰번호 혹은 비밀번호가 맞지 않습니다.</p>
              {/* <Button onClick={() => navigate("/declarelist")}> */}
              <Button onClick={() => navigate('/')}>재확인 필요</Button>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (list[0]?.mw_id !== num) {
    return (
      <div className='declarelist-container'>
        <div className='declarelist-box'>
          <div className='declarelist-contents' style={{ height: '50vh', paddingTop: 50 }}>
            <BiSolidError fontSize={30} />
            <p>작성하신 게시물이 아닙니다.</p>
            <small>다시 확인 부탁드립니다.</small>
            <Button onClick={() => navigate('/')}>재확인 필요</Button>
          </div>
        </div>
      </div>
    );
  }

  if (Object.keys(checkList).length > 0) {
    const renderGridItem = (label, value) => (
      <Grid item xs={12} sm={12}>
        {value && (
          <>
            <FormLabel>{label}</FormLabel>
            <TextField required fullWidth value={value} multiline rows={5} />
            <p style={{ color: 'red' }}>* 조치결과는 수정할 수 없습니다.</p>
          </>
        )}
      </Grid>
    );

    return (
      <main className='declarelist-container'>
        <div className='declarelist-box'>
          <div className='declarelist-contents'>
            <div className='title'>
              <h1>악취신고 내역</h1>
            </div>

            <div className='map-container' style={{ pointerEvents: mapClickEnabled ? 'auto' : 'none' }}>
              <DetailMap checkList={checkList} />
            </div>

            <h2 style={{ textAlign: 'left' }}>신고일시 : {checkList?.rcpt_date}</h2>

            <Grid container spacing={2} sx={{ marginTop: 2, textAlign: 'left' }}>
              <Grid item xs={12} sm={12}>
                <FormLabel>
                  주소* <small>(필수)</small>
                </FormLabel>
                <TextField type='text' required fullWidth value={checkList?.rpt_addr} autoComplete='given-name' />
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormLabel>
                  악취종류* <small>(필수)</small>
                </FormLabel>
                <TextField
                  required
                  fullWidth
                  value={checkList?.type_name}
                  autoComplete='given-name'
                  sx={{
                    backgroundColor: '#0075c1',
                    borderRadius: '4px',
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormLabel>
                  악취강도* <small>(필수)</small>
                </FormLabel>
                <TextField
                  required
                  fullWidth
                  value={checkList?.div_name}
                  autoComplete='given-name'
                  sx={{
                    backgroundColor: '#0075c1',
                    borderRadius: '4px',
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormLabel>
                  추가 요청내용* <small>(선택)</small>
                </FormLabel>
                <TextField required fullWidth htmlFor='description' value={checkList?.rpt_ctnt} autoComplete='given-name' multiline rows={5} />
              </Grid>

              <Grid item xs={12} sm={12}>
                <FormLabel>확인일자</FormLabel>
                <TextField type='text' required fullWidth disabled value={checkList?.proc_date} autoComplete='given-name' size={'small'} />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormLabel>확인사항</FormLabel>
                <TextField required fullWidth disabled value={checkList?.proc_ctnt} multiline rows={5} />
                <p style={{ color: 'red', paddingTop: 2 }}>* 확인사항은 수정할 수 없습니다.</p>
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormLabel>조치결과</FormLabel>
                <TextField required fullWidth disabled value={checkList?.proc_rs} multiline rows={5} />
                <p style={{ color: 'red', paddingTop: 2 }}>* 조치결과는 수정할 수 없습니다.</p>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel>작성자</FormLabel>
                <TextField
                  type='text'
                  id='username'
                  name='username'
                  required
                  fullWidth
                  value={checkList?.rpt_nm}
                  autoComplete='given-name'
                  size={'small'}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormLabel>
                  번호* <small>(필수)</small>
                </FormLabel>
                <TextField
                  type='tel'
                  id='phone'
                  name='phone'
                  required
                  fullWidth
                  value={checkList?.rpt_call}
                  autoComplete='given-name'
                  size={'small'}
                />
              </Grid>
            </Grid>

            <Box
              sx={{
                margin: '8px 0',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button variant='contained' color='error' onClick={handleDeleteConfirmation}>
                삭제하기
              </Button>
              <Button
                sx={{ marginLeft: 2 }}
                variant='contained'
                color={'inherit'}
                onClick={() => {
                  navigate(-1);
                }}
              >
                목록으로
              </Button>
            </Box>
          </div>
        </div>
      </main>
    );
  }
}

export default DeclareAnswer;
